<div class="wizard-composer-preview d-editor-preview-wrapper">
  <div class="d-editor-preview">
    {{html-safe this.field.preview_template}}
  </div>
</div>